module.exports = __webpack_public_path__ + "static/media/01.1c61863d.jpg";